import one360 from './one360';
import type { ExtractSerialNumberResult } from '../../interfaces/serialNumber';

export async function extractSerialNumberFromUpload(
  file: File,
): Promise<ExtractSerialNumberResult> {
  const formData = new FormData();
  formData.append('image', file);
  return one360.post<ExtractSerialNumberResult>('/api/v1/serial-number/extract', formData);
}

export async function extractSerialNumberFromDriveFile(
  fileId: string,
): Promise<ExtractSerialNumberResult> {
  return one360.get<ExtractSerialNumberResult>(
    `/api/v1/serial-number/file/${encodeURIComponent(fileId)}`,
  );
}
